module.exports = __webpack_public_path__ + "static/media/pdf.7adc2798.svg";